import React from 'react';
import Labelize from './Labelize';
import NumberField from '../../atoms/inputField/NumberField';
import { string, bool } from 'prop-types';

const NumberFieldWithLabel = React.forwardRef(({ label, errorMessage, inline, withDecimal, ...props }, ref) => (
  <Labelize label={label} errorMessage={errorMessage} inline={inline} inputName={props.name}  {...props}>
    <NumberField ref={ref} inline={inline} withDecimal={withDecimal} {...props} />
  </Labelize>
));

NumberFieldWithLabel.propTypes = {
  ...NumberField.propTypes,
  label: string,
  withDecimal: bool,
  errorMessage: string
};

export default NumberFieldWithLabel;
